/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */function copyAxisInto(axis,originAxis){axis.min=originAxis.min;axis.max=originAxis.max;}/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */function copyBoxInto(box,originBox){copyAxisInto(box.x,originBox.x);copyAxisInto(box.y,originBox.y);}export{copyAxisInto,copyBoxInto};